import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import {heading} from './Highlight3.module.css'

export default function Highlight3({ data }) {
    const { highlight3ButtonText, highlight3Title, highlight3Text, highlight3ButtonLink, highlight3BackgroundColor } = data
    return (
        <div className={`our-imapct-video-wrap global-comet-vid-wrap ${highlight3BackgroundColor==='blue' ? 'light-grey-bg' : ''}`}>
            <div className='container imapct-vid-cont'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <figure className='abt-origins-icon mb-5'>
                            <StaticImage
                                src='../../../images/origins-icon.png'
                                alt='image'
                            />
                        </figure>
                        <h2 className={`heading-level-4-i text-uppercase text-center ${heading}`}>
                            {highlight3Title && parser(highlight3Title)}
                        </h2>
                        <p>{highlight3Text && parser(highlight3Text)}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
